import { getInitialSelectedVariant } from '@src/components/product-card/product-card.helpers'
import { IWebsiteProduct } from '@src/components/product-card/product-card.types'
import wishlistService from '@src/quince-site-common/src/services/wishlistService'

export const isItemInWishList = (product: IWebsiteProduct) => {
  const selectedVariant = getInitialSelectedVariant({
    cardVariants: product?.cardVariants,
  })
  return wishlistService.isItemInWishlist(product?.relatedIds?.shopifyId, selectedVariant?.displayConfig?.value || '')
}
